// @flow

import Loadable from "react-loadable";
import DynamicImportLoader from "app/components/atoms/DynamicImportLoader/DynamicImportLoader";
import type { InteractivesMenuItemConfig } from "../interactives-list";
import DisplayImage from "./image.png";

const description =
  "A pointer to share information with journalists securely and confidentially";

const CONFIG: InteractivesMenuItemConfig = {
  name: "News-tip pointer",
  id: "news-tip-pointer",
  linkPrefix: "/interactives",
  tags: ["Pointer"],
  description,
  image: DisplayImage,
  adminOnly: false,
  cradleIframeUrlRoot:
    "https://www.smh.com.au/interactive/2020/news-tip-pointer/live/index.html?resizable=true",
  ConfigComponent: Loadable({
    delay: 200, // See 'Avoiding Flash Of Loading Component': https://github.com/jamiebuilds/react-loadable
    loader: () =>
      import(/* webpackChunkName: "NewsTipPointerConfigTool" */ "app/components/tools/NewsTipPointerConfigTool/NewsTipPointerConfigTool"),
    loading: DynamicImportLoader,
    modules: ["NewsTipPointer"]
  })
};

export default CONFIG;
